import * as tslib_1 from "tslib";
import { updateUserOptions } from 'owa-options-core';
import { updateUserConfiguration } from 'owa-options-core';
import getKeyboardShortcutsOptions from '../data/store/store';
export default function saveKeyboardShortcutsOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = getKeyboardShortcutsOptions();
                    updateUserOptions({
                        KeyboardShortcutsMode: optionState.shortcuts,
                    });
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'KeyboardShortcutsMode',
                                propertyType: 'Integer32',
                                propertyValue: "" + optionState.shortcuts,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveKeyboardShortcutsOption.js.map